<form class="is-flex is-align-center" [formGroup]="form">
  <div class="is-flex is-fullwidth gap-8 is-relative">
    <app-icon class="text-24" name="search"/>
    <input #input class="text-18" type="text" formControlName="searchText" [attr.placeholder]="'app.__MAP_SEARCH' | AsyncLang | async" (focus)="focus.next()">
    <app-icon (click)="clear()" class="clear text-24 text-grey-70 is-cursor-pointer" name="clear" />

    @if (places$ | async; as places) {
      @if (places.length > 0) {
        <div class="is-absolute dropdown bg-grey-0 radius-12">
          @for (place of places; track place) {
            <app-text (click)="setPlace(place)" class="place bg-grey-hover-10 is-cursor-pointer">{{ place.properties.label }}</app-text>
          }
        </div>
      }
    }
  </div>
</form>